// Single source for Lancer game data: the core book and supplements installed
// from npm, plus any COMP/CON content packs dropped into src/data/lcps/*.lcp
// (loaded by the lcp plugin in vite.config.ts).

import lancerData from "@massif/lancer-data";
import ktbData from "lancer-ktb-data";
import nrfawData from "lancer-nrfaw-data";
import longrimData from "lancer-longrim-data";

const lcpFiles = import.meta.glob("@/data/lcps/*.lcp", { import: "default", eager: true });

export const core = lancerData;

const sources = [lancerData, ktbData, nrfawData, longrimData, ...Object.values(lcpFiles)];

// Every entry of one kind ("frames", "weapons", "bonds", ...) across all sources
export const all = key => sources.flatMap(data => (Array.isArray(data[key]) ? data[key] : []));

// For reference/debugging: which content packs were picked up
export const contentPacks = Object.entries(lcpFiles).map(([file, data]) => ({
	file: file.split("/").pop(),
	name: data.lcp_manifest?.name || file,
	version: data.lcp_manifest?.version || "",
}));
